<p-select [options]="userDropDownItems" [(ngModel)]="userName" [class]="styleClass"
  placeholder="{{userInfo?.name}}" dropdownIcon="pi pi-user" (onChange)="onUserDropdownItemSelected($event)">

  <ng-template let-item #item>
    <div [attr.title]="item.title ? item.title : null" class="login-menu-item" [attr.data-testid]="item.datatestid">
      <span [class]="item.icon"></span>
      {{item.label}}
    </div>
  </ng-template>
</p-select>
